document.addEventListener('DOMContentLoaded', () => {
  const menuLinks = document.querySelectorAll('#bnt-menu ul li a');
  const tabBoxes = document.querySelectorAll('.tab-main-box .tab-box');

  menuLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent the default action of the link

      // Remove 'active' class from all links
      menuLinks.forEach(link => link.classList.remove('active'));

      // Add 'active' class to the clicked link
      link.classList.add('active');

      // Get the data-rel attribute value
      const targetId = link.getAttribute('data-rel');

      // Hide all tab-boxes
      tabBoxes.forEach(tab => {
        tab.style.display = 'none';
        tab.classList.remove('active');
      });

      // Show the target tab-box
      const targetTab = document.getElementById(targetId);
      if (targetTab) {
        targetTab.style.display = 'block';
        targetTab.classList.add('active');
      }
    });
  });
});
  document.addEventListener('DOMContentLoaded', function() {
    const headers = document.querySelectorAll('.fotr-option-titl');
    
    headers.forEach(header => {
      header.addEventListener('click', function() {
        // Find the next sibling <ul> element and toggle its display
        const ul = this.nextElementSibling;
        if (ul) {
          // Toggle between block and none
          ul.style.display = (ul.style.display === "block") ? "none" : "block";
        }
        
        // Toggle the "active" class on the closest parent with the class .footer-block--menu
        const parentMenu = this.closest('.footer-block--menu');
        if (parentMenu) {
          parentMenu.classList.toggle('active');
        }
      });
    });
  });

document.addEventListener("DOMContentLoaded", function () {
  // Default setup: Enable logo cutout
  let toggleButton = document.querySelector("#toggle");
  let logocutCart = document.querySelector('.cart-cutout');

  if (logocutCart) {
    logocutCart.value = "Enabled"; // Set cart-cutout value to "Enabled"
  }

  if (toggleButton) {
    toggleButton.checked = true; // Set the toggle switch to checked by default
  }

  let logoCutThumbnail = document.querySelector('.thumbnail-list__item[data-alt="logo-cut"] button');
  if (logoCutThumbnail) {
    logoCutThumbnail.click(); // Simulate clicking the logo-cut thumbnail button
  }

  // Handle toggle switch functionality
  if (toggleButton) {
    toggleButton.addEventListener("click", function () {
      let isCLICK = false;

      if (toggleButton.checked) {
        // Enable the logo cutout
        if (logocutCart) logocutCart.value = "Enabled";

        if (logoCutThumbnail) {
          logoCutThumbnail.click();
        }
      } else {
        // Disable the logo cutout
        if (logocutCart) logocutCart.value = "Disabled";

        document.querySelectorAll(".thumbnail-list__item").forEach((cuttof) => {
          if (cuttof.dataset.alt !== "logo-cut" && !isCLICK) {
            isCLICK = true;
            cuttof.querySelector("button").click();
            cuttof.click();
          }
        });
      }
    });
  }
});

// Function to disable scrolling
function disableScrolling() {
  document.body.classList.add('overflow-hidden'); // Add the overflow class
  document.body.style.overflow = 'hidden'; // Fallback for inline styles
  document.body.style.position = 'fixed'; // Prevent scrolling entirely
  document.body.style.width = '100%'; // Avoid content shifting
}

// Function to enable scrolling
function enableScrolling() {
  document.body.classList.remove('overflow-hidden'); // Remove the overflow class
  document.body.style.overflow = ''; // Reset inline styles
  document.body.style.position = '';
  document.body.style.width = '';
}
document.addEventListener('scroll', function () {
  const body = document.body;

  // Check if the body has the 'overflow' class
  if (body.classList.contains('overflow-hidden')) {
    // disableScrolling();
    // Prevent scroll logic from affecting the class
    body.classList.add('overflow-hidden');
  }
  else{
    // enableScrolling()
  }
});

// Optional: MutationObserver to monitor DOM changes
const observer_ = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'class' &&
      !document.body.classList.contains('overflow-hidden')
    ) {
      // Ensure the 'overflow' class is re-added if removed
      document.body.classList.add('overflow-hidden');
    }
  }
});

// Start observing changes to the body element
// observer_.observe(document.body, {
//   attributes: true, // Monitor attribute changes
//   attributeFilter: ['class'], // Only observe changes to the 'class' attribute
// });